import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

import { TranslateService } from 'ng2-translate';
import { Dashboard, DashboardItem } from '../../../model/top.model';
import { DashboardData } from '../../../providers/dashboard-data';
import { EditMode } from '../../../enums/enums'

@Component({
  selector: 'dashboard-details',
  templateUrl: 'dashboard-details.html'
})
export class DashboardDetailsPage {
  private dashboard: Dashboard;
  private mode: EditMode;
  private editMode = EditMode;
  private formGroupDashboard: FormGroup;
  private canLeave: boolean;
  // Uncomment to display alertMessage for validation
  // private validationMessages = {};

  constructor(public navCtrl: NavController, public navParams: NavParams, private formBuilder: FormBuilder, private dashboardData: DashboardData, private alertCtrl: AlertController, private translate: TranslateService) {
    this.dashboard = navParams.get("dashboard");
    this.mode = navParams.get("editMode");
    if (!this.mode) {
      this.mode = this.editMode.edit;
    }
    this.canLeave = false; //this.mode == EditMode.browse;
    this.initFormGroup()
  }

  ionViewCanLeave() {
    if (!this.canLeave && this.mode != this.editMode.browse) {
      let alert = this.alertCtrl.create({
        title: this.translate.instant('ARE_YOU SURE_LEAVE') + '?',
        subTitle: this.translate.instant('ALL_UNSAVED_LOST') + '!',
        buttons: [{
          text: this.translate.instant('NO')
        },
        {
          text: this.translate.instant('YES'),
          handler: data => {
            if (this.mode == this.editMode.edit) {
              this.cancel();
            } else {
              this.canLeave = true;
              this.navCtrl.pop();
            }
          }
        }]
      });
      alert.present();
      return false;
    }
  }

  initFormGroup() {
    // Uncomment to display alertMessage for validation
    // this.validationMessages = {};
    let controlsConfig = {
      dashboardName: [this.dashboard.name, Validators.required]
    };
    // Uncomment to display alertMessage for validation
    // this.validationMessages['dashboardName'] = {};
    // this.validationMessages['dashboardName'].required = "Dashboard naam is verplicht";
    this.dashboard.dashboardItems.forEach(item => {
      controlsConfig[item.uuid] = [item.name, Validators.required];
      // Uncomment to display alertMessage for validation
      // this.validationMessages[item.uuid] = {};
      // this.validationMessages[item.uuid].required = "Item naam is verplicht";
    });
    this.formGroupDashboard = this.formBuilder.group(controlsConfig);
  }

  // For possible future use
  // resetFormGroup() {
  //   let resetObject = {
  //     dashboardName: this.dashboard.name
  //   };
  //    this.dashboard.dashboardItems.forEach(item => {
  //     resetObject[item.uuid] = item.name;
  //   });
  //   this.formGroupDashboard.reset(resetObject);
  // }

  editIcon() {
    alert('edit Icon');
  }

  save() {
    if (this.formGroupDashboard.valid) {
      // update dashboardObject
      this.dashboard.name = this.formGroupDashboard.value.dashboardName;
      for (let item in this.dashboard.dashboardItems) {
        let itemUuid = this.dashboard.dashboardItems[item].uuid;
        this.dashboard.dashboardItems[item].name = this.formGroupDashboard.value[itemUuid];
      }
      if (this.mode == EditMode.new) {
        this.dashboardData.createDashboard(this.dashboard);
        // TODO show success toast
      } else {
        this.dashboardData.setDashboard(this.dashboard).then((result) => {
          if (!result) {
            // TODO show error toast
            throw new Error("Fout bij opslaan");
          } else {
            // TODO show success toast
          }
        });
      }
      this.canLeave = true;
      this.navCtrl.pop();
    } else {
      // let formErrors = "";
      for (const field in this.formGroupDashboard.value) {
        const control = this.formGroupDashboard.get(field);
        // for now only mark all elements as touched
        control.markAsTouched();
        // Uncomment to display alertMessage for validation
        // if (control && !control.valid) {
        //   for (const key in control.errors) {
        //     formErrors += this.validationMessages[field][key] + "<br>";
        //   }
        // }
      }
      // Uncomment to display alertMessage for validation
      // let alert = this.alertCtrl.create({
      //   title: 'Kan niet opslaan',
      //   subTitle: formErrors,
      //   buttons: ['OK']
      // });
      // alert.present();
    }
  }

  cancel() {
    this.canLeave = true;
    // this.resetFormGroup();
    this.navCtrl.pop();
  }

  addDashboardItem() {
    alert('Add Dashboard Item');
  }

  deleteDashboardItem(event, dashboardItem: DashboardItem) {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('DELETE') + '?',
      subTitle:  this.translate.instant('ARE_YOU SURE_DELETE', {value: this.translate.instant('THIS_ITEM').toLowerCase()} ) + '?',
      buttons: [{
        text: this.translate.instant('NO')
      },
      {
        text: this.translate.instant('YES'),
        handler: data => {
          this.dashboardData.deleteDashboardItem(dashboardItem).then((result: Array<Dashboard>) => {
            // console.log(result);
          });
        }
      }]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboards/dashboard-details/dashboard-details.ts